export const USER_ROLES = {
  ADMIN: 'Admin',
  MANAGER: 'Gestor',
  SUPERVISOR: 'Supervisor',
  ANALIST: 'Analista',
  PROSPECT: 'Prospect',
}

export const REVIEWER_ROLES = {
  MANAGER: 'Manager',
  SUPERVISOR: 'Supervisor',
  ANALYST: 'Analyst',
}

export const INTERNAL_USER_ROLE_VALUES = {
  ANALYST: 'Analyst',
  SUPERVISOR: 'Supervisor',
  MANAGER: 'Manager',
  ADMIN: 'Admin',
  ALL: 'Todos',
}

export const INTERNAL_USER_ROLE_LABELS = {
  ANALYST: 'Analista',
  SUPERVISOR: 'Supervisor',
  MANAGER: 'Gestor',
  ADMIN: 'Administrador',
  ALL: 'Todos',
}

export const TRANSLATED_INTERNAL_USER_ROLES = {
  [INTERNAL_USER_ROLE_VALUES.ANALYST]: INTERNAL_USER_ROLE_LABELS.ANALYST,
  [INTERNAL_USER_ROLE_VALUES.SUPERVISOR]: INTERNAL_USER_ROLE_LABELS.SUPERVISOR,
  [INTERNAL_USER_ROLE_VALUES.MANAGER]: INTERNAL_USER_ROLE_LABELS.MANAGER,
  [INTERNAL_USER_ROLE_VALUES.ADMIN]: INTERNAL_USER_ROLE_LABELS.ADMIN,
  'Onboarding Admin': 'Onboarding Admin',
}
